"use client"

import { useState } from "react"
import { List, X } from "lucide-react"
import { cn } from "@/lib/utils"

const sections = [
  { id: "core-philosophy", title: "Core Philosophy", number: "01" },
  { id: "methodological-trinity", title: "The Methodological Trinity", number: "02" },
  { id: "strategy", title: "Strategy", number: "02a" },
  { id: "tactics", title: "Tactics", number: "02b" },
  { id: "processes", title: "Processes", number: "02c" },
  { id: "data-governance", title: "Data Governance & AI", number: "03" },
  { id: "pincer-effect", title: "The Pincer Effect", number: "04" },
  { id: "susana", title: "Susana: Internal AI", number: "05" },
  { id: "conclusion", title: "Conclusion", number: "06" },
]

export function MobileTableOfContents() {
  const [isOpen, setIsOpen] = useState(false)

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
      setIsOpen(false)
    }
  }

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="lg:hidden fixed bottom-6 right-6 z-50 p-4 rounded-full bg-accent-primary text-background shadow-lg shadow-accent-primary/25 hover:scale-105 transition-transform"
        aria-label="Open table of contents"
      >
        <List className="h-5 w-5" />
      </button>

      {/* Drawer Overlay */}
      {isOpen && (
        <div 
          className="lg:hidden fixed inset-0 z-50 bg-background/80 backdrop-blur-sm"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Drawer */}
      <div
        className={cn(
          "lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border rounded-t-2xl transition-transform duration-300 ease-out",
          isOpen ? "translate-y-0" : "translate-y-full"
        )}
      >
        <div className="p-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
              Table of Contents
            </h3>
            <button
              onClick={() => setIsOpen(false)}
              className="p-2 rounded-full hover:bg-muted transition-colors"
              aria-label="Close"
            >
              <X className="h-5 w-5 text-muted-foreground" />
            </button>
          </div>
          
          <nav className="space-y-1 max-h-[60vh] overflow-y-auto pb-safe">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className="w-full text-left px-3 py-3 text-sm rounded-md transition-colors flex items-center gap-3 text-muted-foreground hover:text-foreground hover:bg-muted/50"
              >
                <span className="font-mono text-xs opacity-60">{section.number}</span>
                <span className={section.number.includes("a") || section.number.includes("b") || section.number.includes("c") ? "pl-2" : ""}>
                  {section.title}
                </span>
              </button>
            ))}
          </nav>
        </div>
      </div>
    </>
  )
}
